module.exports = __webpack_public_path__ + "static/media/13062597_1289113007769868_529686000_o.de2b8246.jpg";